/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ServiceAccountsControllerGetApiSettingsQueryResponse, ServiceAccountsControllerGetApiSettingsPathParams, ServiceAccountsControllerGetApiSettings400, ServiceAccountsControllerGetApiSettings401, ServiceAccountsControllerGetApiSettings403, ServiceAccountsControllerGetApiSettings404 } from "../../models/serviceAccountsController/ServiceAccountsControllerGetApiSettings";

function getServiceAccountsControllerGetApiSettingsUrl(orgId: ServiceAccountsControllerGetApiSettingsPathParams["orgId"]) {
  const res = { method: 'GET', url: `/api/v1/organizations/${orgId}/api-settings` as const }  
  return res
}

/**
 * @summary Read the organization API version pin, supported versions and active-key limit
 * {@link /api/v1/organizations/:orgId/api-settings}
 */
export async function serviceAccountsControllerGetApiSettings(orgId: ServiceAccountsControllerGetApiSettingsPathParams["orgId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ServiceAccountsControllerGetApiSettingsQueryResponse, ResponseErrorConfig<ServiceAccountsControllerGetApiSettings400 | ServiceAccountsControllerGetApiSettings401 | ServiceAccountsControllerGetApiSettings403 | ServiceAccountsControllerGetApiSettings404>, unknown>({ method : "GET", url : getServiceAccountsControllerGetApiSettingsUrl(orgId).url.toString(), ... requestConfig })  
  return res.data
}